import React from "react";
import Link from "gatsby-link";
// import ClassNames from 'classnames'

class Reviews extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    if (window.Yotpo) {
      var api = new Yotpo.API(yotpo);
      api.refreshWidgets();
    } else {
      var e = document.createElement("script");
      (e.type = "text/javascript"),
        (e.async = true),
        (e.src =
          "//staticw2.yotpo.com/vZxrWB8nlZlNXL078cEM8dC3RU4OWEaVZDPYT1wX/widget.js");
      var t = document.getElementsByTagName("script")[0];
      t.parentNode.insertBefore(e, t);
    }
  }

  render() {
    return (
      <div className="Reviews">
        <div>
          <div id="Reviews" className="header">
            <h3>Customer Reviews</h3>
          </div>
          <div
            className="yotpo yotpo-main-widget"
            data-product-id={this.props.sku}
            data-price={this.props.product.price}
            data-currency="USD"
            data-name={this.props.product.title}
            data-url={this.props.url}
            data-image-url={this.props.product.images[0].originalSrc}
            data-description={this.props.product.description}
          />
        </div>
      </div>
    );
  }
}

export default Reviews;



// WEBPACK FOOTER //
// ./src/buy/reviews.js